/**
 * Copyright (c) Amur 2020
 *
 * React-js-loader by Amur
 * https://github.com/AmurKhoyetsyan/react-js-loader
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Heart = _interopRequireDefault(require("./Heart"));
var _Box = _interopRequireDefault(require("./Box/Box1"));
var _Box2 = _interopRequireDefault(require("./Box/Box2"));
var _Box3 = _interopRequireDefault(require("./Box/Box3"));
var _Box4 = _interopRequireDefault(require("./Box/Box4"));
var _Box5 = _interopRequireDefault(require("./Box/Box5"));
var _Box6 = _interopRequireDefault(require("./Box/Box6"));
var _Box7 = _interopRequireDefault(require("./Box/Box7"));
var _Bubble = _interopRequireDefault(require("./Bubble/Bubble1"));
var _Bubble2 = _interopRequireDefault(require("./Bubble/Bubble2"));
var _Bubble3 = _interopRequireDefault(require("./Bubble/Bubble3"));
var _Bubble4 = _interopRequireDefault(require("./Bubble/Bubble4"));
var _Bubble5 = _interopRequireDefault(require("./Bubble/Bubble5"));
var _Spinner = _interopRequireDefault(require("./Spinner/Spinner1"));
var _Spinner2 = _interopRequireDefault(require("./Spinner/Spinner2"));
var _Spinner3 = _interopRequireDefault(require("./Spinner/Spinner3"));
var _Ekvalayzer = _interopRequireDefault(require("./Ekvalayzer"));
var _Hourglass = _interopRequireDefault(require("./Hourglass"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function (nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
const Loader = props => {
  const [defaultProps, setProps] = (0, _react.useState)({
    type: "spinner-default",
    bgColor: "#FFFFFF"
  });
  (0, _react.useEffect)(() => {
    if (Object.keys(props).length === 0) {
      props = defaultProps;
    }
    let newProps = {
      ...props
    };
    if (!newProps.hasOwnProperty("type")) {
      newProps.type = defaultProps.type;
    }
    if (!newProps.hasOwnProperty("bgColor")) {
      newProps.bgColor = defaultProps.bgColor;
    }
    setProps(newProps);
  }, [props]);
  switch (defaultProps.type) {
    case "box-rotate-x":
      return _react.default.createElement(_Box.default, defaultProps);
    case "box-rotate-y":
      return _react.default.createElement(_Box2.default, defaultProps);
    case "box-rotate-z":
      return _react.default.createElement(_Box3.default, defaultProps);
    case "box-rectangular":
      return _react.default.createElement(_Box4.default, defaultProps);
    case "rectangular-ping":
      return _react.default.createElement(_Box5.default, defaultProps);
    case "box-up":
      return _react.default.createElement(_Box6.default, defaultProps);
    case "ping-cube":
      return _react.default.createElement(_Box7.default, defaultProps);
    case "heart":
      return _react.default.createElement(_Heart.default, defaultProps);
    case "bubble-scale":
      return _react.default.createElement(_Bubble.default, defaultProps);
    case "bubble-top":
      return _react.default.createElement(_Bubble2.default, defaultProps);
    case "bubble-ping":
      return _react.default.createElement(_Bubble3.default, defaultProps);
    case "bubble-spin":
      return _react.default.createElement(_Bubble4.default, defaultProps);
    case "bubble-loop":
      return _react.default.createElement(_Bubble5.default, defaultProps);
    case "spinner-cub":
      return _react.default.createElement(_Spinner.default, defaultProps);
    case "spinner-circle":
      return _react.default.createElement(_Spinner2.default, defaultProps);
    case "spinner-default":
      return _react.default.createElement(_Spinner3.default, defaultProps);
    case "ekvalayzer":
      return _react.default.createElement(_Ekvalayzer.default, defaultProps);
    case "hourglass":
      return _react.default.createElement(_Hourglass.default, defaultProps);
    default:
      return _react.default.createElement(_Spinner3.default, defaultProps);
  }
};
var _default = Loader;
exports.default = _default;